"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerContextInjector = exports.ServerContextProvider = exports.ServerContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const server_context_1 = require("../../atom/server-context");
const utils_1 = require("jotai/utils");
exports.ServerContext = (0, react_1.createContext)({});
const ServerContextProvider = ({ children, context }) => {
    return (0, jsx_runtime_1.jsx)(exports.ServerContext.Provider, { value: context, children: children });
};
exports.ServerContextProvider = ServerContextProvider;
const ServerContextInjector = () => {
    const value = (0, react_1.useContext)(exports.ServerContext);
    if (__BUILD_TARGET__ === 'server') {
        (0, utils_1.useHydrateAtoms)([[server_context_1.$ServerContext, value]]);
    }
    return null;
};
exports.ServerContextInjector = ServerContextInjector;
